module.exports = __webpack_public_path__ + "static/media/MaskGroup31.99766c72.png";